var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGinger = function SvgGinger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ginger_svg__a)",
    d: "M36 152q-1-1-1-2c0-1-.66-1.48-.56-1.86C34.68 147.2 31 145 31 143c0-3 3-4 3.85-7.91.38-1.74 5.6-10.75 6.5-11.44s9.83-9.97 12.42-11.07 10.31-5.02 19.08-5.89c8.77-.86 16.08-.98 19.37 0s9.32 3.38 9.62 3.88.3 2.09.91 2.28 2.8 2.15 3.05 3.38 2.25 1.78 2.74 3.01 1.64 3.2 2.07 4.8.45 3.38.77 3.71c.21.21 1.62 1.25 1.62 2.25s-1.99 2.51-1.99 2.51L45.44 154s-8.86-1.42-9.44-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ginger_svg__b)",
    d: "M208.29 96c7.05 0 15.4 3.16 16.85 5.34s6.02 11.17 8.18 13.11 6.26 7.28 5.29 14.08-2.05 9.71-2.77 10.2c0 0 2.45 2.31 2.91 4.49.46 2.19.14 4.61 0 6.31s-1.29 2.85-2.25 3.82-7.28 3.34-8.24 2.73-2.53.36-3.25.73-2.89 1.7-5.29 1.7-4.09-.61-5.66 0-5.66-.97-6.38-.61-3.97.28-5.66.75-2.41-.47-3.13 0c0 0-1.18 2.19-3.18 3.21s-4.16 1.99-4.88 1.75-1.93.73-2.53 1.34-12.63.36-13.36 0c-.72-.36-2.29-1.21-2.89-.97s-.24 1.58-2.05 1.7-13.8.81-16.36 1.29-13.24 2.02-14.6 2.43-2.17-.32-2.73 0-1.93 1.29-2.65.81-2.97-1.78-4.25-1.62-3.93.73-4.57.73-2.17-.4-3.53.24c-1.36.65-10.83 1.46-13.24 2.19s-8.18 2.19-10.59 1.94c-2.41-.24-12.03.78-13.32.03s-5.37-1.56-7.54-3.34-4.25-.65-5.05-.49-4.01-.16-4.25-1.05-1.12-2.59-1.97-2.63-7.74-1.25-9.79-.65c-2.05.61-9.63-.24-9.99-1.21s-.6-1.21-1.38-2-2.95-1.64-4.15-2.25-3.25-3.16-2.89-3.88.52-2.31-.04-2.79c-.2-.18-.67-.94-1.14-1.42q-1-1-1-2c0-1 .98-1.57 2-2 6.45-2.74 27.7-9.04 34.36-9.15 7.7-.12 10.95-.97 12.15-1.46s9.51-2.31 11.79-3.03c2.29-.73 19.25-4.25 21.18-4.98s17.81-6.19 20.52-6.8 14.38-3.52 15.1-4.25 9.02-8.25 11.43-9.71 14.56-4.49 17.69-5.22 8.54-2.67 10.47-3.76 11.91-3.64 16.61-3.64z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ginger_svg__a",
    x1: 106.39,
    x2: 27.63,
    y1: 143.92,
    y2: 116.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1988BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ginger_svg__b",
    x1: 228.49,
    x2: -38,
    y1: 137.83,
    y2: 128.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1988BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgGinger;